import React from 'react';
import { Input } from 'baseui/input';
import { Button } from 'baseui/button';
import { Card, StyledBody } from 'baseui/card';
import { HeadingSmall, LabelMedium, ParagraphMedium } from 'baseui/typography';
import { Tag, KIND } from 'baseui/tag';
import useCheckUserSegment from './useCheckUserSegment';

const CheckUserSegment: React.FC<{}> = () => {
	const { userId, setUserId, segmentName, setSegmentName, loading, result, handleCheck, handleBack } = useCheckUserSegment();

	return (
		<div style={{ padding: '24px', maxWidth: '600px' }}>
			<HeadingSmall>Check User Live Segment</HeadingSmall>
			<ParagraphMedium>Check if a user is currently in a specific live segment.</ParagraphMedium>

			<div style={{ marginBottom: '16px' }}>
				<LabelMedium>Zupee User ID</LabelMedium>
				<Input
					value={userId}
					onChange={(e) => setUserId((e.target as HTMLInputElement).value)}
					placeholder='Enter Zupee User ID'
					disabled={loading}
				/>
			</div>

			<div style={{ marginBottom: '16px' }}>
				<LabelMedium>Segment Name</LabelMedium>
				<Input
					value={segmentName}
					onChange={(e) => setSegmentName((e.target as HTMLInputElement).value)}
					placeholder='Enter Segment Name'
					disabled={loading}
					onKeyDown={(e) => {
						if (e.key === 'Enter') handleCheck();
					}}
				/>
			</div>

			<div style={{ display: 'flex', gap: '12px', marginBottom: '24px' }}>
				<Button onClick={handleCheck} isLoading={loading}>
					Check
				</Button>
				<Button onClick={handleBack} kind='secondary'>
					Back
				</Button>
			</div>

			{result && (
				<Card>
					<StyledBody>
						{result.found ? (
							<div style={{ marginBottom: '8px' }}>
								<Tag closeable={false} kind={KIND.positive}>
									User IS in segment: {result.segmentName}
								</Tag>
							</div>
						) : (
							<div style={{ marginBottom: '8px' }}>
								<Tag closeable={false} kind={KIND.negative}>
									User is NOT in segment: {result.segmentName}
								</Tag>
							</div>
						)}
						{result.userSegments.length > 0 && (
							<div style={{ marginTop: '12px' }}>
								<LabelMedium>All live segments for this user:</LabelMedium>
								<div style={{ marginTop: '8px', display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
									{result.userSegments.map((seg) => (
										<Tag
											key={seg}
											closeable={false}
											kind={
												seg.toLowerCase() === result.segmentName.toLowerCase() ? KIND.positive : KIND.neutral
											}>
											{seg}
										</Tag>
									))}
								</div>
							</div>
						)}
					</StyledBody>
				</Card>
			)}
		</div>
	);
};

export default CheckUserSegment;
